import base from '../../src/base';
export default base('footer');